module.exports = __webpack_public_path__ + "static/img/detail-wireless.8afa970f.png";